import { Command } from 'cmdk'
import { Search } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'

// Searchable picker for the console's long-list selects (destination-plate pickers, Cup pickers,
// user pickers) — the plain native <select> equivalent has no type-to-filter, which gets
// unwieldy well before a business hits even a few dozen Plates.
export function Combobox({ value, onValueChange, options, placeholder = 'Search…' }: {
  value: string
  onValueChange: (value: string) => void
  options: { value: string; label: string }[]
  placeholder?: string
}) {
  const [open, setOpen] = useState(false)
  const wrapRef = useRef<HTMLDivElement>(null)
  const selected = options.find((o) => o.value === value)

  useEffect(() => {
    if (!open) return
    const onClick = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [open])

  return (
    <Command ref={wrapRef} className="relative" loop>
      <div className="relative">
        <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none" />
        <Command.Input
          onFocus={() => setOpen(true)}
          placeholder={selected?.label ?? placeholder}
          className="field pl-11"
        />
      </div>
      {open && (
        <Command.List className="absolute z-[100000] top-full left-0 right-0 mt-2 max-h-64 overflow-y-auto custom-scrollbar rounded-2xl border border-gray-200 bg-white p-2 shadow-theme-lg">
          <Command.Empty className="px-3 py-2.5 text-sm text-gray-500 text-center">No match</Command.Empty>
          {options.map((o) => (
            <Command.Item
              key={o.value}
              value={o.label}
              onSelect={() => { onValueChange(o.value); setOpen(false) }}
              className="rounded-lg px-3 py-2.5 text-sm font-medium text-gray-700 cursor-pointer data-[selected=true]:bg-gray-100"
            >
              {o.label}
            </Command.Item>
          ))}
        </Command.List>
      )}
    </Command>
  )
}
